module.exports = __webpack_public_path__ + "6e1cacf46ad1dc9236706b1ee84dcaf0.png";